module.exports = __webpack_public_path__ + "static/media/A1.e3c50c74.pdf";